import { enabledLanguages, localizationData, defaultLanguage, fallbackLanguage } from '../../../Intl/setup';
import { SWITCH_LANGUAGE } from './IntlActions';

// Côté serveur, ne pas lire navigator.language (Node/Docker → souvent en-US).
// Le SSR ne négocie pas encore Accept-Language : on garde la langue de référence,
// initLanguage corrige ensuite côté client.
// Côté client, normaliser fr-FR → fr, ne garder que les langues activées,
// et retomber sur l'anglais si la langue du visiteur n'est pas traduite.
function resolveInitLocale() {
    const isBrowser = typeof window !== 'undefined';
    if(!isBrowser) {
        return defaultLanguage;
    }
    const raw = (global.navigator && global.navigator.language) || fallbackLanguage;
    const short = String(raw).split('-')[0];
    return enabledLanguages.indexOf(short) !== -1 ? short : fallbackLanguage;
}

const initLocale = resolveInitLocale();

const initialState = {
    isInit: false,
    locale: initLocale,
    enabledLanguages,
    messages: (localizationData[initLocale] || {}).messages || {},
};

const IntlReducer = (state = initialState, action) => {
  switch(action.type) {

    case SWITCH_LANGUAGE: {
      const { type, locale, messages } = action; // eslint-disable-line
          return {
              ...state,
              isInit: true,
              locale,
              messages,
          };
  }

    default:
      return state;
  }
};

export default IntlReducer;
